export default __webpack_public_path__ + "static/media/gotmy-placeholder-1.3d898f97.jpeg";